// extracted by mini-css-extract-plugin
export var acitonButtons = "_ez-0";
export var additionalIcon = "_ez-f";
export var block = "_ez-1";
export var blockContent = "_ez-7";
export var blockDescription = "_ez-8";
export var blockIcon = "_ez-9";
export var blockTitle = "_ez-6";
export var border = "_ez-a";
export var center = "_ez-l";
export var edge = "_ez-b";
export var edgeLabel = "_ez-c";
export var edgePath = "_ez-d";
export var error = "_ez-e";
export var flowchart = "_ez-g";
export var flowchartContent = "_ez-h";
export var highlighted = "_ez-3";
export var hover = "_ez-4";
export var icon = "_ez-i";
export var left = "_ez-m";
export var navButton = "_ez-j";
export var navButtons = "_ez-k";
export var right = "_ez-n";
export var selected = "_ez-2";
export var small = "_ez-5";